import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from '@/components/ui/card';
import { TabsContent } from '@/components/ui/tabs';

import { TabProps } from '../tabConfig';
import { LobTable } from './table';

export function LobsTab({ importTypeId, importTypeName }: TabProps) {
	return (
		<TabsContent value="lobs">
			<Card>
				<CardHeader>
					<CardTitle>Line of Businesses</CardTitle>
					<CardDescription>
						Line of Business Mappings for {importTypeName} - {importTypeId}
					</CardDescription>
				</CardHeader>
				<CardContent className="space-y-2">
					<LobTable importTypeId={importTypeId} />
				</CardContent>
			</Card>
		</TabsContent>
	);
}
